module.exports = __webpack_public_path__ + "img/179943.0cf464d8.png";